import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client/react";
import { notifications } from "@mantine/notifications";
import * as yup from "yup";
import { useNavigate } from "react-router-dom";
import { CreationForm } from "../../components/form/CreationForm";

const CREATE_MARKETPLACE_APP_MUTATION = gql`
  mutation publishMarketplaceApp($input: PublishMarketplaceAppInput!) {
    publishMarketplaceApp(input: $input) {
      id
      name
      status
    }
  }
`;

export function CreateMarketplaceApp() {
  const navigate = useNavigate();
  const [createApp] = useMutation(CREATE_MARKETPLACE_APP_MUTATION);

  return (
    <CreationForm
      title="Create Marketplace App"
      schemaDefinition={{
        name: {
          type: "INPUT",
          label: "App Name",
          yupConfig: yup.string().required().min(1).max(100),
          inputType: "text",
          placeholder: "My Awesome App",
        },
        shortDescription: {
          type: "TEXTAREA",
          label: "Short Description",
          yupConfig: yup.string().required().min(1).max(256),
          placeholder: "A brief description for app cards",
        },
        description: {
          type: "RICH_TEXT_EDITOR",
          label: "Description",
          yupConfig: yup.string().required().min(1).max(2000),
        },
        icon: {
          type: "INPUT",
          label: "Icon URL",
          yupConfig: yup.string().url().nullable(),
          inputType: "url",
          placeholder: "https://...",
        },
        categories: {
          type: "MULTI_SELECT",
          label: "Categories",
          yupConfig: yup.array().of(yup.string()),
          options: [
            { label: "Tournaments", value: "tournaments" },
            { label: "Events", value: "events" },
            { label: "Analytics", value: "analytics" },
            { label: "Moderation", value: "moderation" },
            { label: "Social", value: "social" },
            { label: "Commerce", value: "commerce" },
            { label: "Utility", value: "utility" },
            { label: "Content", value: "content" },
          ],
        },
        version: {
          type: "INPUT",
          label: "Version",
          yupConfig: yup
            .string()
            .required()
            .matches(/^\d+\.\d+\.\d+$/, "Must be semver format"),
          inputType: "text",
          defaultValue: "1.0.0",
          placeholder: "1.0.0",
        },
        privacyPolicyUrl: {
          type: "INPUT",
          label: "Privacy Policy URL",
          yupConfig: yup.string().url().nullable(),
          inputType: "url",
          placeholder: "https://...",
        },
        supportUrl: {
          type: "INPUT",
          label: "Support URL",
          yupConfig: yup.string().url().nullable(),
          inputType: "url",
          placeholder: "https://...",
        },
      }}
      onSubmit={async (values) => {
        const result = await createApp({
          variables: {
            input: {
              ...values,
              manifest: {
                version: "1.0",
                permissions: ["organization:marketplace:view"],
                extensions: [],
                webhookEvents: [],
                metafieldNamespaces: [],
                frontendModules: [],
              },
              screenshots: [],
              categories: values.categories ?? [],
            },
          },
        });

        if (result.error) {
          throw new Error((result.error as any).message);
        }

        notifications.show({
          title: "App Created",
          message: "Your marketplace app has been created in DRAFT status.",
          color: "green",
          autoClose: 3000,
        });

        navigate("/developer/apps");
      }}
    />
  );
}
